module.exports = __webpack_public_path__ + "img/nuevas-tecnologias.cc3164ab.jpg";